export default __webpack_public_path__ + "static/media/Spiderward Breastplate.efd5e650.jpg";